/**
 * Preserves current query parameters when navigating
 * @param path - The path to navigate to (without query params)
 * @param searchParams - Current search params from useSearchParams()
 * @returns Path with preserved query parameters
 */
export const preserveQueryParams = (path: string, searchParams: URLSearchParams): string => {
  const queryString = searchParams.toString();

  if (!queryString) {
    return path;
  }

  const separator = path.includes('?') ? '&' : '?';
  return `${path}${separator}${queryString}`;
};
